import { STATUSPAGE } from '@repo/ui';
import { HandleActivitiesSummarizedByStudentUseCaseInterface } from 'domain/usecases';
import { notifyError } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { useAppSelector } from 'presentation/config/hooks/useRedux';
import {
  clearActivitiesSummarizedByStudent,
  loadActivitiesSummarizedByStudent,
} from 'presentation/config/store/reports/handle-activities-summarized-by-student';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

export const useActivitiesSummarizedByStudent = () => {
  const [statusGet, setStatusGet] = useState<STATUSPAGE>();
  const [hasFetchedData, setHasFetchedData] = useState(false);
  const dispatch = useDispatch();
  const { activitiesSummarizedByStudentService } = useService();

  const { data: summarizedByStudent } = useAppSelector(
    (state) => state.activitiesSummarizedByStudent,
  );

  const handleActivitiesSummarizedByStudentFile = useCallback(
    async (
      params?: HandleActivitiesSummarizedByStudentUseCaseInterface.Params,
    ) => {
      setStatusGet(STATUSPAGE.LOADING);

      await activitiesSummarizedByStudentService
        .execute(params)
        .then((res: any) => {
          let blob = new Blob([res], {
            type: `application/${params?.type === '0' ? 'pdf' : 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'}`,
          });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, '_blank');
        })
        .catch((err) => console.log(err))
        .finally(() => {
          setStatusGet(STATUSPAGE.DONE);
        });
    },
    [],
  );

  const requestActivitiesSummarizedByStudentJSON = useCallback(
    async (
      params?: HandleActivitiesSummarizedByStudentUseCaseInterface.Params,
    ) => {
      setStatusGet(STATUSPAGE.LOADING);

      await activitiesSummarizedByStudentService
        .execute(params)
        .then((res) => {
          dispatch(loadActivitiesSummarizedByStudent(res));
        })
        .catch((err) => {
          dispatch(clearActivitiesSummarizedByStudent());
          notifyError(err.message);
        })
        .finally(() => {
          setStatusGet(STATUSPAGE.DONE);
          setHasFetchedData(true);
        });
    },
    [],
  );

  return {
    statusGet,
    hasFetchedData,
    summarizedByStudent,
    handleActivitiesSummarizedByStudentFile,
    requestActivitiesSummarizedByStudentJSON,
  };
};
